// this is pared down because we DO NOT want to register it
export default {
  parse : ( field, context ) => {
    const toReturn = {
      type : 'ExpressionField.invalid'
    }
    if ( context?.includeAstInfo && !( typeof field === 'string' ) ) {
      toReturn.absoluteLocation = {
        startIndex : field.startIndex,
        endIndex : field.endIndex,
      }
      toReturn.relativeLocation = {
        startIndex : 0,
        endIndex : field.value.length,
      }
    }
    return toReturn
  }
}
